import { Select } from 'foundations-components/transitional/components/Select';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const VariantSelectErrorState = () => /*#__PURE__*/_jsx(Select, {
  "data-test-id": "variant-select-error",
  minInlineSize: "200px",
  menuWidth: 400,
  buttonUse: "tertiary-light",
  buttonSize: "small",
  disabled: true,
  error: true,
  valueRenderer: () => /*#__PURE__*/_jsx(Text, {
    use: "error",
    as: "span",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "personalizationLib.variantSelect.error"
    })
  })
});
export default VariantSelectErrorState;